// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/external_source.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file studyo/today/schools/v1/resources/external_source.proto.
 */
export const file_studyo_today_schools_v1_resources_external_source = /*@__PURE__*/
  fileDesc("CjdzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvZXh0ZXJuYWxfc291cmNlLnByb3RvEiFzdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMiewoORXh0ZXJuYWxTb3VyY2USEwoLc291cmNlX25hbWUYASABKAkSEwoLZXh0ZXJuYWxfaWQYAiABKAkSCwoDdXJsGAMgASgJEjIKDmxhc3Rfc3luY190aW1lGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEIpqgImU3R1ZHlvLlRvZGF5LlNjaG9vbHMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * Describes the message studyo.today.schools.v1.resources.ExternalSource.
 * Use `create(ExternalSourceSchema)` to create a new message.
 */
export const ExternalSourceSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_external_source, 0);

